import { graphql } from "@/lib/gql/__generated__";

export const RESERVATION_DETAIL_ISSUE_RECEIPT_FOR_MANAGEMENT_RESERVATION_ITEM_DETAIL_MUTATION =
	graphql(/* GraphQL */ `
		mutation ReservationDetailIssueReceiptForManagementReservationItemDetail(
			$input: ReservationDetailIssueReceiptInput!
		) {
			reservationDetailIssueReceipt(input: $input) {
				reservationDetail {
					statusReceiptIssued
				}
				pdfUrl
				userErrors
			}
		}
	`);
